import React, { useState, useRef } from 'react';
//import { useNavigate, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie';
import bgLogin from '../assets/images/bg.jpg';
import bgGolfClubVideo from '../assets/video/bg-golfclub.webm';
import bgGolfClubVideo2 from '../assets/video/bg-golfclub-2.webm';
import bgGolfClubVideo3 from '../assets/video/bg-golfclub-3.webm';
import pcCaddie from '../assets/images/pcc.svg';
import logoIcon from '../assets/logo.svg';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuthStore } from '../store/authStore';
import axiosInstance from '../axiosConfig';

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [clubNumber, setClubNumber] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const setToken = useAuthStore((state) => state.setToken);
  const setRole = useAuthStore((state) => state.setRole);
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const videoList = [bgGolfClubVideo, bgGolfClubVideo2, bgGolfClubVideo3];

  /*
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const refValue = queryParams.get('ref');

  if (refValue === 'dev') {
    Cookies.set('isDevUser', 'true', { expires: 7 }); // Store a cookie for 7 days
  } else if (!Cookies.get('isDevUser')) {
    window.location.href = 'https://old.kadermeldung.de';
  }*/

  const handleSubmit = async (event: React.FormEvent) => {
    setLoading(true);
    event.preventDefault();
    try {
      const response = await axiosInstance.post('/login', {
        club_number: clubNumber,
        email: email,
        password: password,
      });
      const { token, role } = response.data;
      setToken(token);
      setRole(role);
      navigate('/league?ref=login-page');
    } catch (error) {
      console.error('Error logging in:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex min-h-full flex-1 bg-dotdot">
        <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <img alt="Your Company" src={logoIcon} className="h-10 w-auto" />
              <h2 className="mt-8 text-2xl/9 font-bold tracking-tight text-gray-900">
                Login
              </h2>
              <p className="mt-2 text-sm/6 text-gray-500">
                Bitte geben Sie Ihre Zugangsdaten ein. Beachten Sie bitte, dass
                die Clubnummer 7-stellig - also 049XXXX eingegeben werden muss.
              </p>
            </div>

            <div className="mt-10">
              <form onSubmit={handleSubmit}>
                <div className="space-y-6 grid">
                  <div>
                    <div className="grid w-full max-w-sm items-center gap-1.5">
                      <Label htmlFor="club_number">Clubnummer:</Label>
                      <Input
                        type="text"
                        id="club_number"
                        placeholder="7-stellige Nummer"
                        value={clubNumber}
                        onChange={(e) => setClubNumber(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="flex gap-4">
                    <div>
                      <div className="grid w-full max-w-sm items-center gap-1.5">
                        <Label htmlFor="email">E-Mail-Adresse:</Label>
                        <Input
                          type="email"
                          id="email"
                          placeholder="Ihre E-Mail-Adresse"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>

                    <div>
                      <div className="grid w-full max-w-sm items-center gap-1.5">
                        <Label htmlFor="password">Passwort</Label>
                        <Input
                          type="password"
                          id="password"
                          placeholder="Ihr Passwort"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <Button disabled={loading} type="submit" className={`w-full`}>
                    {loading ? (
                      'Bitte warten ...'
                    ) : (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                          />
                        </svg>{' '}
                        Am System anmelden
                      </>
                    )}
                  </Button>

                  <hr />

                  <div className="flex gap-2 items-center text-sm">
                    <span className="relative -top-1">
                      Hergestellt mit ❤️ von:
                    </span>
                    <a
                      href="https://pccaddie.com/?ref=kadermeldung"
                      target="_blank"
                    >
                      <img className="h-4" src={pcCaddie} alt="" />
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div
          ref={videoRef}
          className="relative min-h-screen bg-primary hidden w-0 flex-1 lg:block"
        >
          <video
            className="absolute inset-0 size-full object-cover"
            autoPlay
            loop
            muted
            playsInline
            poster={bgLogin}
          >
            <source
              src={videoList[Math.floor(Math.random() * 3)]}
              type="video/webm"
            />
            <img
              src={bgLogin}
              alt="Background"
              className="absolute inset-0 size-full object-cover"
            />
          </video>
          <a
            target={'_blank'}
            className="absolute bottom-4 right-4 z-50 text-xs text-white opacity-50"
            href="https://www.vecteezy.com/free-videos/golf"
          >
            Golf Stock Videos by Vecteezy
          </a>
        </div>
      </div>
    </>
  );
}
